import cookieHelper from "@irati/utils/cookies"

export default function clearCookie(COOKIE_NAME: string) {
  try {
    cookieHelper.removeItem(COOKIE_NAME, "/", getDomain())
  } catch (e) {
    // no-op
  }
}

function getDomain() {
  const {hostname} = location
  const domain = hostname.substring(hostname.lastIndexOf(".", hostname.lastIndexOf(".") - 1) + 1)
  return `.${domain}`
}
